import { Box } from '@mui/material';
import { StyledTable, StyledTd, StyledTh, StyledTr } from '../styles/table';
import { PDPAccessorySize } from '@/data/types/PdpSizes';

interface Props {
	data: PDPAccessorySize[];
}

export const ProductDetailsAccessoriesScenery: React.FC<Props> = ({ data }) => {
	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				gap: '20px',
			}}
		>
			<Box
				sx={{
					overflowY: 'auto',
					flex: 1,
				}}
			>
				<StyledTable>
					<thead>
						<tr>
							<StyledTh>{'Talla'}</StyledTh>
							<StyledTh>{'CM'}</StyledTh>
							<StyledTh>{'Pulgadas'}</StyledTh>
						</tr>
					</thead>
					<tbody>
						{data.map((item) => (
							<StyledTr key={item.size}>
								<StyledTd>{item.size}</StyledTd>
								<StyledTd>{item.cm}</StyledTd>
								<StyledTd>{item.in}</StyledTd>
							</StyledTr>
						))}
					</tbody>
				</StyledTable>
			</Box>
		</Box>
	);
};
